import { useChatInstancesStore } from './chatInstancesStore';

export const hasActiveChat = (chatId: string): boolean =>
  Boolean(useChatInstancesStore.getState().configs.get(chatId)?.sendMessage);
